export const verify = async (token: string) => {
    try {
        const response = await fetch(`https://edge.api.mvneizzimobile.mx/api/v1.1/test/access`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        if (response.status === 200) {
            //se usa helmet para evitar man in the middle
            // y otros metodos de seguridad del lado del servidor
            const responseBody = response.json()
            return responseBody
        }
        return { code: 401 };
    }
    catch {
        return { code: 401 };
    }
}